import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaSlidersH, FaTools, FaHandSparkles, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Serviço de Regulagem
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/servicoregulagem.css'; // CSS específico para esta página

const ServicoRegulagem = () => {
  const galleryImages = [
    { 
      id: 1, 
      src: '/img/regulagem/1.jpg', 
      alt: 'Ajustes finos que restauram a precisão e o toque original do piano.' 
    },
    { 
      id: 2, 
      src: '/img/regulagem/2.jpg', 
      alt: 'Técnicas de regulagem que alinham cada detalhe da mecânica com a sonoridade perfeita.' 
    },
    { 
      id: 3, 
      src: '/img/regulagem/3.jpg', 
      alt: 'Garantia de resposta suave e consistente em cada tecla.' 
    },
  ];

  const regulagemSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Serviço de Regulagem de Piano",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Ajuste preciso da estrutura mecânica do piano para alinhar teclas, martelos e otimizar a qualidade sonora. Trabalho artesanal que exige profundo conhecimento.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/regulagem"
};



  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];
  return (
    <div className="servico-regulagem-container">
      <SeoHead
  title="Serviço de Regulagem de Piano | Waldir Pianos"
  description="Ajuste fino da mecânica do seu piano para garantir o alinhamento perfeito das teclas e otimizar a qualidade do som. Profissionalismo e precisão para seu instrumento."
  keywords="regulagem piano, alinhamento teclado piano, conserto teclado piano, ajuste piano, Waldir Pianos"
  image="/img/regulagem/1.jpg" 
  url="https://pianoswaldir.com.br/regulagem"
  canonicalUrl="https://pianoswaldir.com.br/regulagem"
  schemaMarkup={regulagemSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="servico-regulagem-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="servico-regulagem-header-content">
          <motion.h1
            className="servico-regulagem-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaSlidersH className="servico-regulagem-title-icon" />
            Serviço de Regulagem
            <span className="servico-regulagem-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="servico-regulagem-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            A precisão que seu piano merece
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="servico-regulagem-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="servico-regulagem-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="servico-regulagem-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="servico-regulagem-section-title">
              <FaTools className="servico-regulagem-section-icon" />
              Harmonia entre Teclado e Mecanismo
            </h2>

            <p className="servico-regulagem-classic-text">
              "De tempos em tempos são necessários ajustes na complexa estrutura mecânica do piano, para que as teclas estejam em perfeito alinhamento com o mecanismo interno. Este serviço é chamado de regulagem."
            </p>

            <div className="servico-regulagem-modern-text">
              <p>É fácil notar quando um piano está desregulado, pelo desalinhamento do teclado e dos próprios martelos, notas prendendo e qualidade de som comprometida.</p>
              <p>Embora não envolva peças ou materiais em sua execução. O serviço de regulagem exige um profundo conhecimento profissional, sensibilidade e paciência para se atingir a perfeição. Praticamente um trabalho artesanal.</p>
            </div>

            <div className="servico-regulagem-benefits-grid">
              <div className="servico-regulagem-benefit-item">
                <FaSlidersH className="servico-regulagem-benefit-icon" />
                <span>Ajuste fino de todos os componentes</span>
              </div>
              <div className="servico-regulagem-benefit-item">
                <FaHandSparkles className="servico-regulagem-benefit-icon" />
                <span>Melhora da resposta do teclado</span>
              </div>
              <div className="servico-regulagem-benefit-item">
                <FaCheckCircle className="servico-regulagem-benefit-icon" />
                <span>Restauração da qualidade sonora original</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

       <motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Regulagem</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="servico-regulagem-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="servico-regulagem-footer-text">Seu piano precisa de ajuste fino?</p>
        <motion.a
          href="tel:1122565987"
          className="servico-regulagem-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default ServicoRegulagem;